import { gql } from 'graphql-request';

import { InitiateMemberDataExportOutput } from '../types';
import { axiosQuery } from '../utils/axiosQuery';

const MUTATION = gql`
  mutation InitiateMemberDataExport {
    initiateMemberDataExport {
      status
    }
  }
`;

export const initiateMemberDataExport = () =>
  axiosQuery<InitiateMemberDataExportOutput>('InitiateMemberDataExport', MUTATION);
